import { get } from 'lodash';
export function state(initialState) {
  return {
    csrftoken: get(initialState, 'authentication.csrftoken', null),
    session: get(initialState, 'authentication.session', null),
  };
}
